import { Component, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { deepClone } from '@lx/shared/utils';
import { SortingCriteria } from '@lx/shared/types';
import { ResidenceCountry, ResidenceCountryService } from '@lx/shared/data-access/destination';
import { Subscription } from 'rxjs';
import { QuoteToolStore } from '@lx/quote-tool/shared/store';
import { StepService } from '@lx/quote-tool/shared/services';
import { CountriesExperimentsService } from '@lx/quote-tool/shared/experiments';

@Component({
  selector: 'lx-residence-country-selector',
  templateUrl: './residence-country-selector.component.html',
  styleUrls: ['./residence-country-selector.component.scss'],
})
export class ResidenceCountrySelectorComponent implements OnInit, OnDestroy, OnChanges {
  @Input() small = false;
  @Input() label: string;
  @Input() disabled = false;
  @Input() placeholder: string;
  @Input() value: string | undefined;
  @Input() sortCriteria: SortingCriteria<ResidenceCountry> = [{ property: 'name' }];
  @Input() required = false;
  @Input() iconValidation = false;
  @Output() valueChange = new EventEmitter<string>();
  @Output() dropdownClosed = new EventEmitter<void>();

  countriesOfResidence: ResidenceCountry[] = [];
  selectedValue: string | undefined;
  dirty = false;

  private subscription = new Subscription();
  private readonly residenceCountryService = inject(ResidenceCountryService);
  private readonly quoteToolStore = inject(QuoteToolStore);
  private readonly stepService = inject(StepService);
  private readonly countriesExperimentsService = inject(CountriesExperimentsService);

  ngOnInit() {
    this.getItemList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value?.currentValue) {
      this.selectedValue = changes.value.currentValue;
      // emit the event to allow the system be aware that this value has changed (even if this
      // change was done programmatically)
      this.valueChange.emit(this.selectedValue);
      this.setResidenceData();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private getItemList() {
    this.subscription.add(
      this.residenceCountryService.getAll().subscribe((data) => {
        this.countriesOfResidence = data.map(deepClone);
        this.quoteToolStore.updateCountriesOfResidence(this.countriesOfResidence);
        this.setResidenceData();
      }),
    );
  }

  private setResidenceData() {
    if (!this.countriesExperimentsService.isCountryExperimentActive()) {
      return;
    }
    this.stepService.setResidenceData({
      countryOfResidence: this.selectedValue,
      residenceCurrency: this.stepService.getResidenceData()?.residenceCurrency,
      countryPhoneCode: this.countriesOfResidence?.find((country) => country?.code === this.selectedValue)?.phoneCode,
    });
  }
}
